import { HTTP_Request } from "../utils/interceptor";
import { BASE_URL } from "../utils/constant";
import { Endpoints } from "./endpoint";
import axios from "axios";

const RewardService = (query) => {
  
    return HTTP_Request.get(BASE_URL + Endpoints.users.rewardHist+query);
  }
  export {RewardService}